export function PencilLineIcon({ className }: { className?: string }) {
	return (
		<svg
			viewBox='0 0 14.6665 14.6664'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path
				d='M7.99992 13.3337H13.3333M9.33325 2.66699L11.9999 5.33366M13.4493 3.87492C13.8018 3.52254 13.9998 3.04457 13.9999 2.54616C13.9999 2.04775 13.802 1.56973 13.4496 1.21725C13.0972 0.864781 12.6193 0.666729 12.1209 0.666667C11.6224 0.666604 11.1444 0.864537 10.792 1.21692L1.89462 10.1163C1.73984 10.2706 1.62537 10.4606 1.56129 10.6696L0.680623 13.5709C0.663393 13.6286 0.662092 13.6898 0.676857 13.7482C0.691622 13.8065 0.721903 13.8597 0.764487 13.9023C0.807071 13.9448 0.86037 13.975 0.918729 13.9896C0.977087 14.0043 1.03833 14.0029 1.09596 13.9856L3.99796 13.1056C4.20674 13.0421 4.39674 12.9283 4.55129 12.7743L13.4493 3.87492Z'
				stroke='currentColor'
				strokeWidth={1.33333}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}
